import React, { useRef } from 'react';
import QRCode from 'react-qr-code';
import { jsPDF } from 'jspdf';
import QRCodeGenerator from 'qrcode';

import ModalComponent from 'components/common/ModalComponent';
import ButtonComponent from 'components/common/ButtonComponent';
import { QR_TYPES } from 'constants/qr.types';
import PropTypes from 'prop-types';

const BlockQRModal = ({ isOpen, onClose, blockId, blockName }) => {
  const qrRef = useRef(null);

  const handlePrintQR = async () => {
    try {
      // Generate QR code as data URL
      const qrDataUrl = await QRCodeGenerator.toDataURL(
        JSON.stringify({
          qrType: QR_TYPES.BLOCK,
          blockId,
          blockName
        }),
        {
          margin: 1,
          width: 256,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        }
      );

      // Create PDF with sticker dimensions
      const CM_TO_MM = 10;
      const PAGE_WIDTH = 4 * CM_TO_MM; // 40mm
      const PAGE_HEIGHT = 5 * CM_TO_MM; // 50mm
      const MARGIN = 3; // 3mm margin

      // eslint-disable-next-line new-cap
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [PAGE_WIDTH, PAGE_HEIGHT]
      });

      // Header
      pdf.setFontSize(4);
      pdf.setTextColor(5, 81, 13); // #05510d
      pdf.text('greenhouses.app', PAGE_WIDTH / 2, MARGIN + 2, { align: 'center' });

      // QR Code
      const qrSize = 25; // 25mm
      const qrX = (PAGE_WIDTH - qrSize) / 2;
      const qrY = MARGIN + 5;

      pdf.addImage(qrDataUrl, 'PNG', qrX, qrY, qrSize, qrSize);

      // Block name below QR
      pdf.setFontSize(50);
      pdf.setTextColor(0, 0, 0);
      pdf.text(blockName, PAGE_WIDTH / 2, qrY + qrSize + 4, { align: 'center' });

      // Footer
      pdf.setFontSize(3);
      pdf.setTextColor(5, 81, 13); // #05510d
      pdf.text('www.crops.io', PAGE_WIDTH / 2, PAGE_HEIGHT - MARGIN, { align: 'center' });

      // Download the PDF
      pdf.save(`block-qr-${blockId}.pdf`);
    } catch (err) {
      console.error('Failed to print QR:', err);
    }
  };

  return (
    <ModalComponent title="Block QR Code" onClose={onClose} isOpen={isOpen} hideDefaultFooter>
      <div className="space-y-6 max-w-md mx-auto">
        <div className="flex flex-col items-center" ref={qrRef}>
          <QRCode
            value={JSON.stringify({ qrType: QR_TYPES.BLOCK, blockId, blockName })}
            size={180}
          />
          <span className="text-sm text-gray-600 mt-2">Block: {blockName}</span>
        </div>

        <div className="flex justify-end space-x-4 pt-4">
          <ButtonComponent
            onClick={onClose}
            customColorsStyles="bg-gray-100 text-greenPrimary hover:text-white"
          >
            Close
          </ButtonComponent>
          <ButtonComponent onClick={handlePrintQR}>Print QR</ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  );
};

BlockQRModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  blockId: PropTypes.any,
  blockName: PropTypes.string
};

export default BlockQRModal;
